import { render, staticRenderFns } from "./NoFacilityCard.vue?vue&type=template&id=1b145ce8&scoped=true&"
import script from "./NoFacilityCard.vue?vue&type=script&lang=js&"
export * from "./NoFacilityCard.vue?vue&type=script&lang=js&"
import style0 from "./NoFacilityCard.vue?vue&type=style&index=0&id=1b145ce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b145ce8",
  null
  
)

export default component.exports